import { eventLabelsConstants } from "../../../constants/event/eventLabel.constants";

const defaultState = {
    groups: {},
    error: false,
    loading: false
};


export function eventLabel(state = defaultState, action) {
    switch (action.type) {
        case eventLabelsConstants.GET_GROUP_EVENTLABEL_REQUEST:
            var groups = Object.assign({}, state.groups);
            groups[action.groupName] = {};
            groups[action.groupName].loading = true;
            return {
                ...state,
                groups,
                loading: true
            };
        case eventLabelsConstants.GET_GROUP_EVENTLABEL_SUCCESS:
            var groups = Object.assign({}, state.groups);
            groups[action.groupName] = action.group;
            return {
                ...state,
                groups,
                loading: false
            };
        case eventLabelsConstants.GET_GROUP_EVENTLABEL_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            };
        case eventLabelsConstants.CREATE_EVENTLABEL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case eventLabelsConstants.CREATE_EVENTLABEL_SUCCESS:
            const groupName = action.label.groupName;
            var groups = Object.assign({}, state.groups);
            groups[action.groupName].push(action.label)
            return {
                ...state,
                groups,
                loading: false
            };
        case eventLabelsConstants.CREATE_EVENTLABEL_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            };

        default:
            return state;
    }
}
